<template>
    <div>
        <div ref="tableContent" class="table-box no-padding">
            <el-table
                ref="table"
                class="my-table-list"
                :data="tableData"
                style="width: 100%"
                :height="tableHeight"
                :row-key="rowKey"
                :tree-props="treeProps"
                border
                @sort-change="tableMixins.handleSortChange"
                @selection-change="tableMixins.handleSelectionChange"
            >
                <slot name="pre"></slot>
                <template v-for="(item,i) in columns">
                    <el-table-column
                        v-if="!item.special"
                        :key="'columns' + i"
                        :prop="item.prop"
                        :label="item.label"
                        :type="item.type"
                        :index="item.index"
                        :column-key="item['column-key']"
                        :width="item['width']"
                        :min-width="item['min-width']"
                        :fixed="item['fixed']"
                        :render-header="item['render-header']"
                        :sortable="item['sortable']"
                        :sort-method="item['sort-method']"
                        :sort-by="item['sort-by']"
                        :sort-orders="item['sort-orders']"
                        :resizable="item['resizable']"
                        :formatter="item['formatter']"
                        :show-overflow-tooltip="item['show-overflow-tooltip']"
                        :align="item['align']"
                        :header-align="item['header-align']"
                        :class-name="item['class-name']"
                        :label-class-name="item['label-class-name']"
                        :selectable="item['selectable']"
                        :reserve-selection="item['reserve-selection']"
                        :filters="item['filters']"
                        :filter-placement="item['filter-placement']"
                        :filter-multiple="item['filter-multiple']"
                        :filter-method="item['filter-method']"
                        :filtered-value="item['filtered-value']"
                    />
                    <slot v-else :name="item.prop"></slot>
                </template>
                <slot name="fixed"></slot>
            </el-table>
        </div>
        <div class="page my-page-list">
            <el-pagination
                :page-sizes="[10, 20, 50, 100]"
                layout="total, prev, pager, next, sizes, jumper"
                :total="tableMixins.totalCount"
                :page-size="tableMixins.filterObj.pagesize"
                :current-page="tableMixins.filterObj.page"
                @size-change="tableMixins.handleSizeChange"
                @current-change="tableMixins.handleCurrentChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'tableList',
    inject: ['layout', 'tableMixins'],
    props: {
        tableData: {
            type: Array,
            default() {
                return [];
            }
        },
        columns: {
            type: Array,
            default() {
                return [];
            }
        },
        treeProps: {
            type: Object,
            default() {
                return {};
            }
        },
        rowKey: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            tableHeight: 400
        };
    },
    watch: {
        'layout.screenHeight'() {
            this.getTableHeight();
        }
    },
    created() {
        this.getTableHeight();
    },
    methods: {
        getTableHeight() {
            this.$nextTick(() => {
                try {
                    let table = document.querySelector('.my-table-list');
                    let page = document.querySelector('.my-page-list');
                    if (table) {
                        let tableTop = table.getBoundingClientRect().top;
                        let pageHeight = page ? page.getBoundingClientRect().height : 0;
                        this.tableHeight = window.innerHeight - tableTop - pageHeight - 20;
                    }
                } catch (e) {
                    console.log(e);
                }
            });
        },
        resetSelection() {
            this.$refs.table.clearSelection();
        }
    }
};
</script>
